<template>
  <b-overlay
    variant="white"
    spinner-variant="primary"
    blur="0"
    opacity=".75"
    rounded="sm"
    :show="loading"
  >
    <b-card v-if="tripStatesList.length">
      <b-card-title> Active Trip </b-card-title>
      <b-table
        responsive
        striped
        :fields="activeTripColumns"
        :items="tripStatesList"
        show-empty
        empty-text="No matching records found"
        class="text-center"
        thead-class="text-nowrap"
        tbody-class="text-nowrap"
      />
    </b-card>
  </b-overlay>
</template>

<script>
import {
  BTable, BCard, BCardTitle, BOverlay,
} from 'bootstrap-vue'
import useActiveTrip from '@/views/driver-user-shared/driver-user-trips/hooks/useActiveTrip'

export default {
  components: {
    BTable, BCard, BCardTitle, BOverlay,
  },
  props: {
    type: {
      type: String,
      default: '',
    },
  },
  setup(props, ctx) {
    return {
      ...useActiveTrip(props, ctx),
    }
  },
}
</script>

<style>

</style>
